<!-- For DB links, use routerLink and routerLinkActive -->
<a *ngIf="variant === 'db-link'; else actionLink" [routerLink]="route" routerLinkActive="active-link" (click)="handleClick()"
   class="navlink {{ variantClass }} {{ customClass }}">
  <ng-container *ngIf="iconPath">
    <img [src]="iconPath" [alt]="label + ' icon'" class="w-5 h-5 shrink-0 {{ iconClass }}" />
  </ng-container>

  <!-- Label -->
  <span class="block overflow-hidden text-ellipsis whitespace-nowrap" [title]="label | translate">
    {{ label | translate }}
  </span>
</a>

<!-- Otherwise, fallback to plain click action -->
<ng-template #actionLink>
  <a (click)="handleClick()" class="navlink {{ variantClass }} {{ customClass }}">
    <ng-container *ngIf="iconPath">
      <img [src]="iconPath" [alt]="label + ' icon'" class="w-3 h-3 shrink-0 {{ iconClass }} rtl:rotate-180" />
    </ng-container>
    <span class="block overflow-hidden text-ellipsis whitespace-nowrap" [title]="label | translate">
      {{ label | translate }}
    </span>
  </a>
</ng-template>